module.exports = __webpack_public_path__ + "media/AUDIO 06.1b947d6a.mp3";